import { AxiosMethods } from '@setvi/shared/enums';
import { axiosHelper } from '@setvi/shared/services';
import { UseQueryOptions } from '@tanstack/react-query';

export type Status = {
  label: string;
  icon: string;
  value: string;
};

export const getOrderStatuses = (): UseQueryOptions<Status[]> => ({
  queryKey: ['order_statuses'],
  queryFn: () =>
    axiosHelper({
      endpoint: '/order/statuses',
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_API
    }),
  refetchOnWindowFocus: false
});

export const getOrderItemsStatuses = (): UseQueryOptions<Status[]> => ({
  queryKey: ['order_items_statuses'],
  queryFn: () =>
    axiosHelper({
      endpoint: '/order-items/statuses',
      method: AxiosMethods.GET,
      baseURL: process.env.REVOPS_API
    }),
  refetchOnWindowFocus: false
});
